import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type {
	IAccessRequest,
	IAccessRequests,
	IGuestClient,
	IStatusRequest,
} from '@interfaces/guestClient';
import type { IParameters } from '@interfaces/parameters';

export interface IGetGuestClientsParams {
	status?: string;
	inactive?: boolean;
	tenantId?: number;
	page?: number;
	pageLimit?: number;
}

@Injectable({
	providedIn: 'root',
})
export class GuestClientsService {
	constructor(private readonly _http: HttpClient) {}

	getSettings() {
		return this._http.get<IParameters>('guest_clients/settings');
	}

	validateEmail(data: { email: string }) {
		return this._http.get<any>('guest_clients/check-availability', {
			params: (<unknown>data) as HttpParams,
		});
	}

	getGuestClients(queryParams?: IGetGuestClientsParams) {
		return this._http.get<IAccessRequests>('guest_clients/solicitations', {
			params: (<unknown>queryParams) as HttpParams,
		});
	}

	postClient(client: IGuestClient) {
		return this._http.post<IGuestClient>(`guest_clients`, client);
	}

	updateStatus(id: IGuestClient['id'], status: IStatusRequest) {
		return this._http.put<IAccessRequest>(
			`guest_clients/solicitations/${id}`,
			status
		);
	}
}
